import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconChannelSprinklr = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          d="M1.72639 5.61543C1.80139 4.48106 2.73664 3.49818 3.97189 3.57393C4.30864 3.61143 4.72039 3.61143 5.35677 4.10306C8.12577 6.56043 9.77277 10.8711 9.28602 14.6136C9.24852 14.8026 9.06139 14.8026 8.98639 14.6136C8.20077 11.9293 5.61814 8.86706 3.33514 7.92168C2.24989 7.50581 1.65139 6.71193 1.72639 5.61543Z"
          fill="#FAA21B"
        />
        <path
          d="M8.87383 18.8104C8.16283 16.4667 4.64533 12.5723 2.06233 12.5723C1.78246 12.5677 1.50465 12.621 1.24638 12.7289C0.98812 12.8369 0.754988 12.9971 0.561654 13.1995C0.36832 13.402 0.218966 13.6422 0.122988 13.9051C0.027009 14.1681 -0.0135174 14.4481 0.00395743 14.7274C0.0789574 16.0129 1.16421 16.6557 2.13733 16.6557C4.34533 16.6557 7.00258 17.6007 8.64958 18.9619C8.76171 19.0373 8.91133 18.9619 8.87383 18.8104Z"
          fill="#70BF54"
        />
        <path
          d="M12.0556 21.6082C12.0181 21.7972 11.8306 21.7972 11.756 21.6082C8.83658 12.4207 14.0765 2.32609 17.9686 2.25071C20.0273 2.21246 21.4493 3.72521 21.4493 5.42621C21.4493 6.59808 21.0751 7.54346 19.7281 8.29946C16.322 10.2277 12.5045 15.2182 12.0556 21.6078V21.6082Z"
          fill="#00BAE9"
        />
        <path
          d="M15.3506 18.9238C15.2381 18.9992 15.0885 18.9238 15.126 18.7723C15.837 16.4286 19.3553 12.5342 21.9375 12.5342C22.2174 12.5295 22.4953 12.5828 22.7536 12.6908C23.0119 12.7987 23.2451 12.9589 23.4384 13.1613C23.6318 13.3637 23.7812 13.604 23.8772 13.867C23.9732 14.1299 24.0137 14.4099 23.9963 14.6893C23.9213 15.9748 22.8356 16.6176 21.8625 16.6176C19.692 16.6176 17.0348 17.6383 15.3506 18.9238Z"
          fill="#128ACB"
        />
      </SvgIcon>
    );
  })
);
